import { euro, euroDezimal } from "./preisAnalyse.js";

/**
 * Fragen und Antworten für die Anlass-Seiten. Die Fragen stammen aus der
 * Search Console, die Zahlen aus dem Katalog.
 */

export function geburtstagFaq(analyse, digital) {
  if (!analyse) return [];
  return [
    {
      question: "Was kostet eine Fotobox für eine Geburtstagsfeier?",
      answer: `Für ${analyse.gaeste} Gäste reichen rund ${analyse.bedarf} Ausdrucke. Passende Pakete mit Drucker beginnen bei ${euro(analyse.min)} €, die Hälfte liegt unter ${euro(analyse.median)} € — etwa ${euroDezimal(analyse.proGast)} € pro Gast.${digital ? ` Ohne Drucker geht es ab ${euro(digital.min)} €; die Gäste bekommen ihre Bilder dann per QR-Code aufs Handy.` : ""}`,
    },
    {
      question: "Gibt es eine günstige Fotobox für kleine Geburtstagsfeiern?",
      answer: digital
        ? `Ja. Bei einer kleinen Feier reicht oft ein rein digitales Paket ohne Drucker — die beginnen bei ${euro(digital.min)} €. Der Unterschied ist nicht die Bildqualität, sondern dass niemand einen Ausdruck in die Hand bekommt. Für eine Party unter Freunden fällt das kaum auf, bei einem runden Geburtstag mit älteren Gästen schon.`
        : "Für kleine Feiern reichen Pakete mit kleinem Druckkontingent; sie sind deutlich günstiger als Flatrate-Pakete.",
    },
    {
      question: "Passt eine Fotobox in eine Wohnung?",
      answer:
        "Ja. Nötig sind etwa zwei mal zwei Meter freie Fläche vor der Box und eine normale Steckdose. Achtet bei niedrigen Altbaudecken darauf, ob ein Hintergrundsystem hineinpasst — eine helle, einfarbige Wand tut es auch.",
    },
    {
      question: "Lohnt sich eine Fotobox zum Kindergeburtstag?",
      answer: `Kinder nutzen die Box intensiver als jede andere Gästegruppe — ein festes Druckkontingent ist bei zehn Kindern in zwei Stunden aufgebraucht. Mit einer Druck-Flatrate (${analyse.mitFlatrate} der passenden Fotoboxen) spielt die Menge keine Rolle. Praktisch ist außerdem ein Hocker vor der Box, weil die Kamera auf Erwachsene eingestellt ist.`,
    },
    {
      question: "Wie lange sollte man die Fotobox mieten?",
      answer:
        "Die Miete gilt bei den meisten Anbietern für den ganzen Tag oder das Wochenende, nicht stundenweise. Stellt die Box deshalb auf, bevor die Gäste kommen — die ersten Bilder entstehen erfahrungsgemäß in der ersten halben Stunde.",
    },
    {
      question: "Wie viele Bilder werden auf einer Geburtstagsfeier gemacht?",
      answer: `Rechnet mit zwei bis drei Ausdrucken pro Gast, bei ${analyse.gaeste} Gästen also rund ${analyse.bedarf} Bildern. Die meisten Gäste gehen mehrfach in die Box — einmal allein, einmal mit dem Tisch, einmal spät am Abend.`,
    },
  ];
}

export function firmenfeierFaq(analyse) {
  if (!analyse) return [];
  return [
    {
      question: "Was kostet eine Fotobox für eine Firmenfeier?",
      answer: `Für ${analyse.gaeste} Gäste sind rund ${analyse.bedarf} Ausdrucke einzuplanen. Passende Pakete beginnen bei ${euro(analyse.min)} €, die Hälfte liegt unter ${euro(analyse.median)} € — etwa ${euroDezimal(analyse.proGast)} € pro Kopf.`,
    },
    {
      question:
        "Welche Fotobox eignet sich für eine Firmenfeier mit 100 Mitarbeitern?",
      answer: `Eine mit Druck-Flatrate und einem Anbieter, der vor Ort betreut. Bei 100 Gästen entstehen zwei Drittel der Bilder in einem engen Zeitfenster; ein festes Kontingent ist dann schnell aufgebraucht, und vor der Box bildet sich eine Schlange. ${analyse.mitFlatrate} der passenden Fotoboxen bieten eine Flatrate, ${analyse.bauenAuf} Anbieter liefern und bauen selbst auf.`,
    },
    {
      question: "Kann das Firmenlogo auf die Ausdrucke?",
      answer: `Ja — ${analyse.mitEigenemLayout} der passenden Fotoboxen erlauben ein eigenes Drucklayout mit Logo, Anlass und Datum. Die Druckvorlage sollte einige Tage vor dem Termin beim Anbieter liegen, damit er sie einrichten kann.`,
    },
    {
      question:
        "Dürfen die Fotos der Mitarbeitenden weiterverwendet werden?",
      answer:
        "Für die Feier selbst nicht kritisch — wer sich in die Box stellt, tut das freiwillig. Für eine Veröffentlichung im Intranet, auf der Karriereseite oder in sozialen Netzwerken braucht ihr die Einwilligung der Abgebildeten. Ein Hinweisschild neben der Box, das die spätere Verwendung nennt, gehört dazu.",
    },
    {
      question: "Wann sollte man für die Weihnachtsfeier buchen?",
      answer:
        "Im September oder Oktober. Zwischen dem ersten und dritten Adventswochenende feiern die meisten Unternehmen — das sind die Termine, an denen die beliebten Boxen zuerst vergeben sind. Für Dezember-Termine mit Versand lohnt außerdem ein Tag Puffer, weil die Paketdienste ausgelastet sind.",
    },
    {
      question: "Bekommt man eine Rechnung auf die Firma?",
      answer:
        "Ja, alle Anbieter im Vergleich stellen eine Rechnung mit ausgewiesener Umsatzsteuer aus. Wenn ihr eine Bestellnummer oder abweichende Rechnungsanschrift braucht, gebt das direkt bei der Anfrage an — nachträgliche Änderungen sind lästiger als eine Zeile im Anfragefeld.",
    },
    {
      question: "Eignet sich eine Fotobox für eine Messe?",
      answer: `Ja, dort arbeitet sie anders als auf einer Feier: Der Ausdruck mit Logo ist das Werbemittel, das Besucher freiwillig mitnehmen, und die Online-Galerie (${analyse.mitGalerie} der passenden Fotoboxen) liefert Bildmaterial für die Nachbereitung. Plant jemanden am Stand ein, der die Box im Blick behält.`,
    },
  ];
}
